import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const SEOHead = () => {
  const location = useLocation();

  useEffect(() => {
    const updateSEO = () => {
      const path = location.pathname;
      let title = '';
      let description = '';
      let keywords = '';

      switch (path) {
        case '/models':
          title = 'Perodua Car Models 2024 - Syasyah Perodua';
          description = 'Explore all Perodua car models: Myvi, Axia, Ativa, Bezza, Alza, Aruz. Best prices, rebates up to RM4,000. Contact Syasyah for instant quote.';
          keywords = 'perodua models, myvi 2024, axia, ativa, bezza, alza, aruz, perodua price malaysia';
          break;
        
        case '/calculator':
          title = 'Car Loan Calculator - Perodua Malaysia | Syasyah';
          description = 'Calculate your Perodua car loan installments. Free loan calculator with 7-9 years terms. Student loans welcome. WhatsApp for instant approval.';
          keywords = 'car loan calculator, perodua loan, installment calculator, car financing malaysia';
          break;
        
        case '/benefits':
          title = 'Perodua Benefits & Promotions - Rebates Up to RM4,000';
          description = 'Get exclusive Perodua benefits: Early bird gifts, rebates up to RM4,000, customer loyalty rewards. Professional after-sales service nationwide.';
          keywords = 'perodua rebate, car promotion malaysia, perodua benefits, early bird gift';
          break;
        
        case '/contact':
          title = 'Contact Syasyah Perodua - WhatsApp 012-500 6170';
          description = 'Contact Syasyah, your trusted Perodua sales advisor. WhatsApp 012-500 6170 for instant quote, loan consultation, and best car deals.';
          keywords = 'contact perodua advisor, syasyah perodua, whatsapp car consultant malaysia';
          break;
        
        case '/colors':
          title = 'Perodua Car Colors 2024 - All Models Available';
          description = 'Explore all Perodua car colors for Myvi, Axia, Ativa, and more. Choose your perfect color match. Contact Syasyah for color availability.';
          keywords = 'perodua colors, car colors malaysia, myvi colors, axia colors, ativa colors';
          break;
        
        case '/testimonials':
          title = 'Customer Reviews - Syasyah Perodua | 500+ Happy Customers';
          description = 'Read testimonials from 500+ satisfied customers. 98% loan approval rate, 5-star service. Join our happy Perodua family today.';
          keywords = 'perodua testimonials, customer reviews, syasyah reviews, perodua dealer review';
          break;
        
        case '/faq':
          title = 'Perodua FAQ - Loan, Eligibility, Documents | Syasyah';
          description = 'Get answers to common Perodua questions: loan requirements, student eligibility, documents needed, rebates, and more.';
          keywords = 'perodua faq, car loan questions, student car loan, perodua eligibility';
          break;
        
        default:
          title = 'Syasyah Perodua - Your Trusted Advisor | Loan Mudah, Kereta Cepat';
          description = 'Trusted Perodua sales advisor with 500+ happy customers. 98% loan approval rate, student loans welcome, rebates up to RM4,000. WhatsApp 012-500 6170 now!';
          keywords = 'perodua malaysia, car loan easy approval, syasyah perodua, trusted car advisor';
      }

      // Update document title
      document.title = title;

      // Update meta description
      let descMeta = document.querySelector('meta[name="description"]');
      if (!descMeta) {
        descMeta = document.createElement('meta');
        descMeta.name = 'description';
        document.head.appendChild(descMeta);
      }
      descMeta.content = description;

      // Update meta keywords
      let keywordsMeta = document.querySelector('meta[name="keywords"]');
      if (!keywordsMeta) {
        keywordsMeta = document.createElement('meta');
        keywordsMeta.name = 'keywords';
        document.head.appendChild(keywordsMeta);
      }
      keywordsMeta.content = keywords;

      // Update Open Graph title
      let ogTitle = document.querySelector('meta[property="og:title"]');
      if (!ogTitle) {
        ogTitle = document.createElement('meta');
        ogTitle.setAttribute('property', 'og:title');
        document.head.appendChild(ogTitle);
      }
      ogTitle.content = title;

      // Update Open Graph description
      let ogDesc = document.querySelector('meta[property="og:description"]');
      if (!ogDesc) {
        ogDesc = document.createElement('meta');
        ogDesc.setAttribute('property', 'og:description');
        document.head.appendChild(ogDesc);
      }
      ogDesc.content = description;

      // Update canonical URL
      let canonical = document.querySelector('link[rel="canonical"]');
      if (!canonical) {
        canonical = document.createElement('link');
        canonical.rel = 'canonical';
        document.head.appendChild(canonical);
      }
      canonical.href = window.location.href;
    };

    updateSEO();
  }, [location.pathname]);

  return null;
};

export default SEOHead;